var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNineDotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175074",
    "data-name": "Group 175074",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_145263",
    "data-name": "Rectangle 145263",
    transform: "translate(12 12)",
    fill: "#fff",
    stroke: "#ebf1f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menu-2-svgrepo-com",
    transform: "translate(22 22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145025",
    "data-name": "Rectangle 145025",
    width: 3.5,
    height: 3.5,
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145026",
    "data-name": "Rectangle 145026",
    width: 3.5,
    height: 3.5,
    transform: "translate(6.25)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145027",
    "data-name": "Rectangle 145027",
    width: 3.5,
    height: 3.5,
    transform: "translate(12.5)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145028",
    "data-name": "Rectangle 145028",
    width: 3.5,
    height: 3.5,
    transform: "translate(0 6.25)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145029",
    "data-name": "Rectangle 145029",
    width: 3.5,
    height: 3.5,
    transform: "translate(6.25 6.25)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145030",
    "data-name": "Rectangle 145030",
    width: 3.5,
    height: 3.5,
    transform: "translate(12.5 6.25)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145031",
    "data-name": "Rectangle 145031",
    width: 3.5,
    height: 3.5,
    transform: "translate(0 12.5)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145032",
    "data-name": "Rectangle 145032",
    width: 3.5,
    height: 3.5,
    transform: "translate(6.25 12.5)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145033",
    "data-name": "Rectangle 145033",
    width: 3.5,
    height: 3.5,
    transform: "translate(12.5 12.5)",
    fill: "#203662"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineDotIcon);
export default __webpack_public_path__ + "static/media/nine-dotIcon.15a9437b4fd7236082d9495c82c1c109.svg";
export { ForwardRef as ReactComponent };